import { useState, useEffect } from 'react';
import {
  CheckmarkCircleIcon,
  CloseCircleIcon,
  WarningIcon,
  InfoIcon,
} from '../icons';
import * as styles from './index.module.css';

const iconMap = {
  success: CheckmarkCircleIcon,
  error: CloseCircleIcon,
  warning: WarningIcon,
  info: InfoIcon,
};

export default function Toast({
  id,
  type = 'info',
  title,
  message,
  onClose,
  duration = 5000,
}) {
  const [isExiting, setIsExiting] = useState(false);

  useEffect(() => {
    if (duration > 0) {
      const timer = setTimeout(() => {
        setIsExiting(true);
        setTimeout(() => onClose(id), 300);
      }, duration);

      return () => clearTimeout(timer);
    }
    return undefined;
  }, [id, duration, onClose]);

  const handleClose = () => {
    setIsExiting(true);
    setTimeout(() => onClose(id), 300);
  };

  const Icon = iconMap[type] || InfoIcon;

  return (
    <div
      className={`${styles.toast} ${styles[type]} ${isExiting ? styles.toastExiting : ''}`}
    >
      <Icon className={styles.icon} />
      <div className={styles.content}>
        {title && <h4 className={styles.title}>{title}</h4>}
        {message && <p className={styles.message}>{message}</p>}
      </div>
      <button
        type="button"
        className={styles.closeButton}
        onClick={handleClose}
        aria-label="Close"
      >
        ×
      </button>
    </div>
  );
}
